var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-header-plat-a'),_c('v-tab-vertical',{attrs:{"legalItems":_vm.schema.legalItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }